import type { FaireProductEntity } from "../../entity_types/product";

export const p_e3s99sv94y: FaireProductEntity = {
  token: "p_e3s99sv94y",
  type: "product",
  name: "Cherry Vanilla - Soda/Carbonated Drink",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/4af2e1c0e2c28acf4bf2913b709d2d766246fcc00ba06a6bf0c8104498460357.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a09a1847d610cc8e160a72a5b9ea456fcaf9fb2672e024d8b02c8623bed22320.png",
    "https://cdn.faire.com/fastly/1ca3814134f50cea9248f798c6316195899841e06f88d7c4d923c9dd5468d135.png",
    "https://cdn.faire.com/fastly/8a750ddeceaceb0f63bebccb3feebaf7f6da87311dad1f0e7ce323605076ca83.png",
    "https://cdn.faire.com/fastly/4f6596514c8140f057439528dd349c552b421b6b48cf5a74d5858e4043ccef52.png",
  ],
  priceDollars: 28.99,
  description:
    "We pinpointed the cherry pie flavor we were craving with a careful combination of tart morello cherries and the sweet tang of rainier cherries, then rounded things out with the soft and sumptuous taste of vanilla bean.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:12.377Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
